import { useInfiniteQuery } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import NoPermissionText from '@/components/atoms/NoPermissionText';
import QueryWrapper from '@/components/molecules/QueryWrapper';
import InfiniteTable from '@/components/organisms/InfiniteTable';
import { SystemParametersSchema } from '@/constants/SystemParametersConstants';
import { columns } from '@/constants/tableColumns/SystemParametersColumns';
import api from '@/services/apiSgft';
import { userCanSeeTurnstileAccessAndParameters } from '@/utils/handleSavePermissions';

import EmptyIcon from '../../assets/icons/empty.svg';

export const SystemParameters = () => {
	const fetchSystemParameters = async ({ pageParam = 1 }) => {
		try {
			const response = await api.get('system-parameters', {
				params: {
					page: pageParam,
					size: 10,
				},
			});
			const parsedData = SystemParametersSchema.parse(response.data);
			return parsedData;
		} catch (e) {
			toast.error('Erro ao carregar os parâmetros do sistema', {
				theme: 'colored',
				toastId: 'error',
			});
			throw e;
		}
	};

	const {
		data,
		isLoading,
		fetchNextPage,
		isFetchingNextPage,
		hasNextPage,
		isError,
	} = useInfiniteQuery(['system-parameters'], fetchSystemParameters, {
		getNextPageParam: (lastPage) => lastPage.nextPage,
	});

	const parameters = data?.pages.flatMap((page) => page?.parameters) || [];

	if (!userCanSeeTurnstileAccessAndParameters()) return <NoPermissionText />;

	return (
		<div className="mt-4 h-full w-full font-graphie">
			<div className="w-full rounded-md bg-white px-4 py-4">
				<QueryWrapper isLoading={isLoading} isError={isError}>
					{parameters?.length ? (
						<InfiniteTable
							hasNextPage={hasNextPage}
							data={parameters}
							columns={columns}
							fetchNextPage={fetchNextPage}
							isFetchingNextPage={isFetchingNextPage}
							alignTextLeft
							hasConsistentBackground
						/>
					) : (
						<div className="flex h-full w-full flex-col items-center justify-center">
							<img src={EmptyIcon} className="w-40" />
							<div className="w-full text-center text-sm">
								<span className="font-semibold text-blue-800">
									Nenhum parâmetro foi encontrado
								</span>
							</div>
						</div>
					)}
				</QueryWrapper>
			</div>
		</div>
	);
};
